import {
  CreateUserDTO,
  PaginatedUsersResponse,
  UpdateUserDTO,
  User,
} from "@/contracts/auth-api.types";
import { apiRequest } from "./apiClient";

export const userService = {
  /**
   * Lista usuários com suporte à paginação.
   */
  async list(page = 1, limit = 20): Promise<PaginatedUsersResponse | User[]> {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });
    return await apiRequest<PaginatedUsersResponse | User[]>(`/users?${params.toString()}`);
  },

  /**
   * Cria um novo usuário no escopo do tenant atual ou especificado.
   */
  async create(dto: CreateUserDTO): Promise<User> {
    return await apiRequest<User>("/users", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dto),
    });
  },

  /**
   * Atualiza dados de um usuário (nome, status de verificação, roles).
   */
  async update(id: string, dto: UpdateUserDTO): Promise<User> {
    return await apiRequest<User>(`/users/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dto),
    });
  },

  /**
   * Exclui um usuário do sistema.
   */
  async delete(id: string): Promise<void> {
    await apiRequest<void>(`/users/${id}`, {
      method: "DELETE",
    });
  },
};
